// Set to true to publish the drawing course page (route + nav/footer links).
export const SHOW_KURZ_KRESBY = true
